import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsentPopup.css';
import { COOKIE_CONSENT_KEY } from '../../utils/yandexMetrica.js';

function CookieConsentPopup({ onAccept }) {
  const [accepted, setAccepted] = useState(() => {
    if (typeof window === 'undefined') {
      return true;
    }

    return localStorage.getItem(COOKIE_CONSENT_KEY) === 'true';
  });

  function acceptCookies() {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
    setAccepted(true);
    onAccept();
  }

  if (accepted) {
    return null;
  }

  return (
    <div className="cookie-consent-popup">
      <p className="cookie-consent-popup__text">
        Сайт использует cookie и локальное хранилище браузера для корректной
        работы, запоминания вашего выбора и обеспечения технической
        стабильности. Продолжая использование сайта, вы подтверждаете
        ознакомление с информацией об их использовании.
      </p>
      <div className="cookie-consent-popup__actions">
        <button
          className="cookie-consent-popup__button"
          onClick={acceptCookies}
        >
          Принять
        </button>
        <Link to="/cookies-policy/" className="cookie-consent-popup__link">
          Подробнее
        </Link>
      </div>
    </div>
  );
}

export default CookieConsentPopup;
